import pushToRoute from './pushToRoute'
import createNewDynamicFiltersList from './createNewDynamicFiltersList'

export default function toggleDynamicFilterKeyInRoute(props) {
  pushToRoute({
    params: {
      dynamicFilters: createNewDynamicFiltersList(props)
    }
  })
}
